import loadConfig from './loadConfig'

/** loadingConfig is a promise that resolves the the loaded application configuration. */
const loadingConfig = loadConfig('/config.json').config

export default loadingConfig
